import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SearchResultsPageRoutingModule } from './search-results-routing.module';

import { SearchResultsPage } from './search-results.page';
import { CustomerAddressCardModule } from 'src/app/components/customer-address-card/customer-address-card.module';
import { EquipmentCardModule } from 'src/app/components/equipment-card/equipment-card.module';
import { RecommendationCardModule } from 'src/app/components/recommendation-card/recommendation-card.module';
import { QuoteCardModule } from 'src/app/components/quote-card/quote-card.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SearchResultsPageRoutingModule,
    CustomerAddressCardModule,
    EquipmentCardModule,
    RecommendationCardModule,
    QuoteCardModule
  ],
  declarations: [SearchResultsPage]
})
export class SearchResultsPageModule { }
